import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { CommunicationInsightsPageRow } from "../server/supabase-communication-insights-page-service";
import { SupabaseCommunicationInsightsPageService } from "../server/supabase-communication-insights-page-service";

export type SplitInsights = {
  positive: CommunicationInsightsPageRow[];
  negative: CommunicationInsightsPageRow[];
  overall_ctr: number | null;
  generatedAt: string | null;
};

export function splitInsightsByDirection(rows: CommunicationInsightsPageRow[]): SplitInsights {
  if (rows.length === 0) {
    return { positive: [], negative: [], overall_ctr: null, generatedAt: null };
  }
  const byCtrDescending = (
    a: CommunicationInsightsPageRow,
    b: CommunicationInsightsPageRow,
  ): number => Number(b.ctr) - Number(a.ctr);
  const byCtrAscending = (
    a: CommunicationInsightsPageRow,
    b: CommunicationInsightsPageRow,
  ): number => Number(a.ctr) - Number(b.ctr);
  return {
    positive: rows.filter((r) => r.direction === "above_average").sort(byCtrDescending),
    negative: rows.filter((r) => r.direction === "below_average").sort(byCtrAscending),
    overall_ctr: Number(rows[0]!.overall_ctr),
    generatedAt: rows[0]!.created_at,
  };
}

export function useCommunicationInsightsByMoment(
  momentId: string,
): ReturnType<typeof useSupabaseLoader<CommunicationInsightsPageRow[]>> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const { data, error } = await new SupabaseCommunicationInsightsPageService(supabase).getAll(
        account_id,
        {
          order: [{ column: "created_at", dir: "desc" }],
          filter: [{ key: "moment_id", operator: "eq", value: momentId }],
        },
      );
      if (error) throw error;
      return data ?? [];
    },
    [momentId],
  );
}
